import callAPiBase from './base';

const tokenApi = {
  get: () =>
    callAPiBase({
      endpoint: `/api/auth`,
      method: 'GET',
      useToken: true,
    }),
  create: () =>
    callAPiBase({
      endpoint: '/api/auth',
      method: 'POST',
      useToken: true,
    }),
  delete: () =>
    callAPiBase({
      endpoint: `/api/auth`,
      method: 'DELETE',
      useToken: true,
    }),
};

export { tokenApi };
export default tokenApi;
